export const dateHasExpired = (expiryDate: string): boolean => {
  if (expiryDate) {
    try {
      const currentTimeUTC = new Date().toUTCString();
      const currentTime = new Date(currentTimeUTC).getTime();
      const expiryTime = new Date(expiryDate).getTime();

      if (expiryTime < currentTime) {
        return true;
      }
    } catch (e) {
      console.error("Error decoding token: ", e);

      return true;
    }

    return false;
  }

  return true;
};
